import axios from "axios";
import { authHeader } from "../authservice/auth-header";

const API_URL =process.env.VUE_APP_ROOT_API
class IOTService {
  // IOT LOCK CONFIG RELATED APIs

  // Get lock master data setting
  async getHotelIotMaster() {
    const response = await axios.get(API_URL + "iot/hotel/iot-master", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Get lock gateway list
  async getLockGatewayList() {
    const response = await axios.get(API_URL + "iot/hotel/iot-gateway", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Get lock device liar
  async getLockDeviceList(gateway_id, filter = "") {
    const response = await axios.get(
      API_URL + `iot/hotel/${gateway_id}/device` + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Get lock device liar
  async getLockDeviceS(filter = "") {
    const response = await axios.get(
      API_URL + `iot/hotel/all-iot-device` + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Get RFID Encoder list
  async getHotelRFIDEncoder() {
    const response = await axios.get(API_URL + "iot/hotel/rfid-encoder", {
      headers: authHeader(),
    });
    return response.data;
  }

  // update encoder data
  async updateHotelRFIDEncoder(encoder_id, data) {
    const response = await axios.patch(
      API_URL + "iot/hotel/rfid-encoder/" + encoder_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // IOT LOCK KEY LIST RELATED APIs

  // Get Device based Lock key list
  async getKeyList(filter = "") {
    const response = await axios.get(API_URL + "iot/hotel/key" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Get Deive based Lock key log list
  async getKeyLogList(filter = "") {
    const response = await axios.get(
      API_URL + "iot/hotel/device-event" + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Add New device key
  async addNewKey(data) {
    const response = await axios.post(API_URL + "iot/hotel/key", data, {
      headers: authHeader(),
    });
    return response.data;
  }

  // IOT LOCK RELATED APIs

  // GET HOTEL MASTER DATA SETTING APIs
  async getLockMasterData() {
    const response = await axios.get(API_URL + "iot/hotel/iot-master", {
      headers: authHeader(),
    });
    return response.data;
  }

  //LOCK IOT GATEWAY RELATED APIs

  // Get gateway list
  async getGatewayList(filter = "") {
    const response = await axios.get(API_URL + "iot/gateway" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add gateway Data
  async addGateway(data) {
    const response = await axios.post(API_URL + "iot/gateway", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit Gateway Data
  async editGateWayData(gateway_id, data) {
    const response = await axios.patch(
      API_URL + "iot/gateway/" + gateway_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete gateway
  async deleteGateway(gateway_id) {
    const response = await axios.delete(API_URL + "iot/gateway/" + gateway_id, {
      headers: authHeader(),
    });
    return response.data;
  }

  //LOCK IOT DEVICE MODEL RELATED APIs

  // Get device model list
  async getDeviecModelList(filter = "") {
    const response = await axios.get(API_URL + "iot/device-model" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add device model Data
  async addDeviecModel(data) {
    const response = await axios.post(API_URL + "iot/device-model", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit deviec model Data
  async editDeviecModelData(device_model_id, data) {
    const response = await axios.patch(
      API_URL + "iot/device-model/" + device_model_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete device model
  async deleteDeviecModel(device_model_id) {
    const response = await axios.delete(
      API_URL + "iot/device-model/" + device_model_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  //LOCK IOT DEVICE  RELATED APIs

  // Get device  list
  async getDevieceList(filter = "") {
    const response = await axios.get(API_URL + "iot/device" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add device  Data
  async addDeviece(data) {
    const response = await axios.post(API_URL + "iot/device", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit deviec  Data
  async editDevieceData(device__id, data) {
    const response = await axios.patch(
      API_URL + "iot/device/" + device__id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete device
  async deleteDevice(device__id) {
    const response = await axios.delete(API_URL + "iot/device/" + device__id, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Bulk update devices
  async bulkDeviceAdd(data) {
    const response = await axios.post(API_URL + "iot/upload/device-csv", data, {
      headers: authHeader(),
    });
    return response.data;
  }

  //LOCK IOT HOTEL MASTER DATA RELATED APIs

  // Get all hotel master data list
  async getHotelMasterList(filter = "") {
    const response = await axios.get(API_URL + "iot/iot-master" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add hotel based master data
  async addHotelBasedMasterData(data) {
    const response = await axios.post(API_URL + "iot/iot-master", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  //Edit hotel based master data
  async editHotelBasedMasterData(hotel_master_data_id, data) {
    const response = await axios.patch(
      API_URL + "iot/iot-master/" + hotel_master_data_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete hotel based master data
  async deleteHotelMasterData(hotel_master_data_id) {
    const response = await axios.delete(
      API_URL + "iot/iot-master/" + hotel_master_data_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // RFID ENCODER RELATED APIs

  // Get RFID encoders liar
  async getRFIDEncoderList(filter = "") {
    const response = await axios.get(API_URL + "iot/rfid-encoder" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add RFID Encoder data
  async addRFIDEncoder(data) {
    const response = await axios.post(API_URL + "iot/rfid-encoder", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit RFID Encoder data
  async editRFIDEncoder(rfid_encoder_id, data) {
    const response = await axios.patch(
      API_URL + "iot/rfid-encoder/" + rfid_encoder_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete RFID Encoder data
  async deleteRFIDEncoder(rfid_encoder_id) {
    const response = await axios.delete(
      API_URL + "iot/rfid-encoder/" + rfid_encoder_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
}
export default new IOTService();
